











































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import SpesimenLabSvc from "@/services/SpesimenLab";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import {
  dateKeWaktu,
  labelPermintaan,
  waktuKeDate
} from "@/utils/spesimenLab";
import {
  SpesimenLab,
  SpesimenLabKonteks,
  SpesimenLabPayload,
  SpesimenLabPermintaan,
  SpesimenLabPetugas,
  SpesimenLabReferensi
} from "@/types/spesimen_lab";

type KolomWaktu = "waktu_pengambilan" | "waktu_diterima";

@Component({
  components: { VCDateTimePicker }
})
export default class SpesimenLabInputModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ required: true }) readonly register!: string;
  @Prop({ default: null }) readonly editData!: SpesimenLab | null;
  @Prop({ required: true }) readonly konteks!: SpesimenLabKonteks;
  @Prop({ default: () => [] }) readonly permintaan!: SpesimenLabPermintaan[];
  @Prop({ required: true }) readonly referensi!: SpesimenLabReferensi;

  form: SpesimenLabPayload = this.bentukAwal(null);
  galat: Record<string, string> = {};
  menyimpan = false;
  batasWaktu: Date = new Date();

  get dialog(): boolean {
    return this.value;
  }

  set dialog(nilai: boolean) {
    this.$emit("input", nilai);
  }

  get opsiPermintaan(): Array<{ value: number; text: string }> {
    const daftar = [...this.permintaan];
    const tersimpan = this.editData ? this.editData.permintaan : null;

    if (tersimpan && !daftar.some(p => p.id === tersimpan.id)) {
      daftar.push(tersimpan);
    }

    return daftar.map(p => ({
      value: p.id,
      text:
        labelPermintaan(p) +
        (p.status < 0 ? ` (${p.status_label || "dibatalkan"})` : "")
    }));
  }

  get opsiJenis(): Array<{ value: string; text: string }> {
    return this.referensi.jenis.map(o => ({
      value: o.value,
      text:
        o.value === this.referensi.lain || !o.display
          ? o.label
          : `${o.label} (${o.display})`
    }));
  }

  get opsiMetode(): Array<{ value: string; text: string }> {
    return this.referensi.metode.map(o => ({
      value: o.value,
      text: o.display ? `${o.label} (${o.display})` : o.label
    }));
  }

  get opsiPetugas(): SpesimenLabPetugas[] {
    const daftar = [...(storePerawat.listKaryawan as SpesimenLabPetugas[])];
    const tersimpan = this.editData
      ? [this.editData.pengambil, this.editData.penerima]
      : [];

    tersimpan.forEach(petugas => {
      if (petugas && !daftar.some(p => p.id === petugas.id)) {
        daftar.push(petugas);
      }
    });

    return daftar;
  }

  get waktuPengambilanDate(): Date | null {
    return waktuKeDate(this.form.waktu_pengambilan);
  }

  set waktuPengambilanDate(nilai: Date | null) {
    this.form.waktu_pengambilan = dateKeWaktu(nilai);
  }

  get waktuDiterimaDate(): Date | null {
    return waktuKeDate(this.form.waktu_diterima);
  }

  set waktuDiterimaDate(nilai: Date | null) {
    this.form.waktu_diterima = dateKeWaktu(nilai);
    this.isiPenerimaBawaan();
  }

  mounted() {
    if (!storePerawat.listKaryawan.length) {
      storePerawat.actListKaryawanAll();
    }
  }

  @Watch("value")
  onBuka(buka: boolean) {
    if (!buka) {
      return;
    }

    this.batasWaktu = new Date();
    this.form = this.bentukAwal(this.editData);
    this.galat = {};
    this.$nextTick(() => {
      const form = this.$refs.form as any;
      if (form) {
        form.resetValidation();
      }
    });
  }

  bentukAwal(item: SpesimenLab | null): SpesimenLabPayload {
    const permintaan = this.permintaan || [];

    return {
      order_id: item
        ? item.order_id
        : permintaan.length === 1
        ? permintaan[0].id
        : null,
      status: item ? item.status : "available",
      jenis_kode: item ? item.jenis_kode : null,
      jenis_keterangan: item ? item.jenis_keterangan : null,
      waktu_pengambilan: item ? item.waktu_pengambilan : null,
      metode_kode: item ? item.metode_kode : null,
      metode_keterangan: item ? item.metode_keterangan : null,
      lokasi_pengambilan: item ? item.lokasi_pengambilan : null,
      volume: item ? item.volume : null,
      volume_satuan: item ? item.volume_satuan : null,
      status_puasa: item ? item.status_puasa : null,
      kondisi: item ? [...item.kondisi] : [],
      pengambil_user_id: item && item.pengambil ? item.pengambil.id : null,
      waktu_diterima: item ? item.waktu_diterima : null,
      penerima_user_id: item && item.penerima ? item.penerima.id : null,
      catatan: item ? item.catatan : null
    };
  }

  wajib(nilai: unknown): boolean | string {
    if (Array.isArray(nilai)) {
      return nilai.length > 0 || "Wajib diisi";
    }
    return (nilai !== null && nilai !== undefined && nilai !== "") ||
      "Wajib diisi";
  }

  volumeValid(nilai: unknown): boolean | string {
    if (nilai === null || nilai === undefined || nilai === "") {
      return true;
    }
    return Number(nilai) >= 0 || "Volume tidak valid";
  }

  satuanValid(nilai: unknown): boolean | string {
    const adaVolume =
      this.form.volume !== null &&
      this.form.volume !== undefined &&
      this.form.volume !== "";
    return !adaVolume || !!nilai || "Pilih satuan";
  }

  penerimaValid(nilai: unknown): boolean | string {
    return (
      !this.form.waktu_diterima ||
      !!nilai ||
      "Wajib diisi bila waktu diterima diisi"
    );
  }

  catatanValid(nilai: unknown): boolean | string {
    return (
      this.form.status !== "unsatisfactory" ||
      (typeof nilai === "string" && nilai.trim() !== "") ||
      "Tuliskan alasan spesimen tidak memenuhi syarat"
    );
  }

  isiSekarang(kolom: KolomWaktu) {
    this.form[kolom] = dateKeWaktu(new Date());
    if (kolom === "waktu_diterima") {
      this.isiPenerimaBawaan();
    }
  }

  isiPenerimaBawaan() {
    const user: any = userModule.user;
    if (this.form.waktu_diterima && !this.form.penerima_user_id && user) {
      this.form.penerima_user_id = Number(user.id) || null;
    }
  }

  kosongkanPenerimaan() {
    this.form.waktu_diterima = null;
    this.form.penerima_user_id = null;
  }

  async simpan() {
    const form = this.$refs.form as any;
    if (this.menyimpan || (form && !form.validate())) {
      return;
    }

    this.menyimpan = true;
    this.galat = {};

    const payload: SpesimenLabPayload = {
      ...this.form,
      volume:
        this.form.volume === "" || this.form.volume === undefined
          ? null
          : this.form.volume
    };

    try {
      if (this.editData) {
        await SpesimenLabSvc.update(this.editData.id, payload);
      } else {
        await SpesimenLabSvc.create({ ...payload, register_id: this.register });
      }
      appModule.NoticeDelay("Data spesimen disimpan");
      this.dialog = false;
      this.$emit("saved");
    } catch (e) {
      const galat: any = e;
      const daftar = galat && galat.response && galat.response.data
        ? galat.response.data.errors
        : null;
      if (daftar) {
        const hasil: Record<string, string> = {};
        Object.keys(daftar).forEach(kunci => {
          const kolom = kunci.split(".")[0];
          if (!hasil[kolom]) {
            hasil[kolom] = daftar[kunci][0];
          }
        });
        this.galat = hasil;
      }
    } finally {
      this.menyimpan = false;
    }
  }
}
